import React from 'react';
import '../Stylesp/CyberProtectPackages.css';

// Import the new card images
import businessmanWorking from '../../assets/businessman_working.png';
import technologyBackground from '../../assets/technology_background.png';
import qualityControl from '../../assets/quality_control.png';
import disasterRecoveryRestoring from '../../assets/disaster_recovery_restoring.png';
import futureEmail from '../../assets/future_email.png';
import uploadingDocuments from '../../assets/uploading_documents_folder.png';

const CyberProtectPackages = () => {
  const packages = [

    {
      title: "Advanced Management (RMM)",
      cardImage: qualityControl,
      items: [
        "Vulnerability assessment (Windows/Mac/Linux along with third-party apps)",
        "Software & Hardware Inventory",
        "Automated patch management",
        "ML-based monitoring",
        "Software deployment",
        "AI-enabled remote scripting, software deployment",
        "Automated pre-patch backup",
        "HDD health monitoring",
        "Next-gen remote desktop assistance (with NEAR Protocol)",
        "Chats between the IT admin and remote users"
      ]
    },
    {
      title: "Advanced Security (EDR)",
      cardImage: technologyBackground,
      items: [
        "Advanced Security + EDR",
        "AI-guided incident investigation, analysis, automated response",
        "Protect against modern threats",
        "Single-click response, attack-specific rollback and recovery",
        "Next Generation Anti-malware",
        "Anti-ransomware protection",
        "Zero-day and exploit protection",
        "URL filtering",
        "Anti-malware scans of backups",
        "Security Awareness training for users",
      ]
    },
    {
      title: "Advanced Email Security",
      cardImage: futureEmail,
      items: [
        "Phishing and Quishing prevention",
        "Business Email Compromise Prevention",
        "Malware protection, APT and zero-day protection",
        "Account takeover detection",
        "Microsoft 365, Google Workspace, Exchange, and any SMTP supporting email service",
        "Threat intelligence, Prevent Account Takeover (ATO), Static signature-based analysis",
        "Anti-spoofing, Anti-evasion",
        "Next-generation dynamic detection, X-ray insights"
      ]
    },
    {
      title: "Advanced Security (XDR)",
      cardImage: disasterRecoveryRestoring,
      items: [
        "Govern, Identify, Protect, Detect, Respond, Recover",
        "ALL EDR features",
        "Endpoint isolation",
        "Forensics backup",
        "Real-time threat intelligence feed",
        "Anti-ransomware detection with automatic rollback",
        "Exploit prevention",
        "Full threat containment including endpoint quarantine and isolation",
        "Single-click response to incidents",
        "Prioritization of suspicious activities",
        "Integration with Email Security (email telemetry), Entra ID (identity), Collaboration Security (for Microsoft 365 apps)"
      ]
    },
    {
      title: "Microsoft 365 & Google Workspace Backup",
      cardImage: uploadingDocuments,
      items: [
        "Unlimited and easy-to-protect Microsoft Teams, Exchange Online, OneNote, OneDrive for Business and SharePoint Online",
        "Unlimited comprehensive, agentless solutions to secure data within Gmail, Google Drive, Google Contacts and Google Calendar",
        "Quick backup search",
        "Multilevel encryption",
        "Geo-redundancy",
        "Complete, blockchain-verified protection",
        "Backup health monitoring and reporting"
      ]
    },
    {
      title: "Advanced Data Protection (Backup & Disaster Recovery)",
      cardImage: businessmanWorking,
      items: [
        "Protection and backup of physical, virtual, cloud and SaaS workloads from one console",
        "Windows, Linux, and Mac backups",
        "Encryption and deduplication, Backup for Microsoft 365",
        "Disaster Recovery - Production and test fail over, Orchestration with runbooks, Automated test failover",
        "Direct Backup to Public Cloud, Fast recovery and less downtime, Built-in security and compliance",
        // "",
        "Compliance-ready protection with audit-ready reporting.",
        "Support application & database-level backup",
        // "Cloud-only VPN connection",
        "Fast Automated Failback with near-zero downtime",
        "Multiple connectivity options",
      ]
    },

  ];

  return (
    <main className="cyber-protect-container">
      <header className="cyber-protect-header">
        <h1>Cyber Protect Advanced packages breakdown, choose <br></br>
          the package you need for your workload</h1>
      </header>
      <section className="packages-grid">
        {packages.map((pkg, index) => (
          <article key={index} className="package-card">
            <figure className="card-image-container">
              <img src={pkg.cardImage} alt={pkg.title} className="card-image" />
            </figure>
            <header className="package-header">
              <h3>{pkg.title}</h3>
            </header>
            <ul>
              {pkg.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>
    </main>
  );
};

export default CyberProtectPackages;